export class DownloadsModel {
  idcampanhas: number = 0;
  iddownloads: number;
  descricao: string = "";
  extensao: string = "";
  idpastas: number = 0;
  habilitado: boolean = true;
  Arquivo: File = null;
}